import vocabTQVMPracticeInstructionStart from '../sounds/vocab_tqvm_practice_instruction_start.mp3';
import vocabTQVMPracticeInstructionStartSpanish from '../sounds/spanish/tqvm_practice_screen_active_state.mp3';
import vocabTQVMPracticeReadyInstruction from '../sounds/vocab_tqvm_practice_ready_instruction.mp3';
import vocabTQVMPracticeReadyInstructionSpanish from '../sounds/spanish/tqvm_practice_screen_ready_state.mp3';
import vocabTQVMQuestionInstructionReplay from '../sounds/vocab_tqvm_question_instruction_replay.mp3';
import vocabTQVMQuestionInstructionReplaySpanish from '../sounds/spanish/selecciona_pulgar.mp3';
import vocabFITBPracticeInstructionStart from '../sounds/vocab_fitb_practice_instruction_start.mp3';
import vocabFITBPracticeInstructionStartSpanish from '../sounds/spanish/fitb_practice_screen_active_state.mp3';
import vocabFITBInstructionReplay from '../sounds/vocab_fitb_practice_instruction_replay.mp3';
import vocabFITBInstructionReplaySpanish from '../sounds/spanish/what_word_fills_in_the_blank.mp3';
import vocabFITBPracticeReadyInstruction from '../sounds/vocab_fitb_practice_ready_instruction.mp3';
import vocabFITBPracticeReadyInstructionSpanish from '../sounds/spanish/fitb_practice_screen_ready_state.mp3';
import vocabBDPracticeInstructionStart from '../sounds/vocab_bd_practice_instruction_start.mp3';
import vocabBDPracticeInstructionStartSpanish from '../sounds/spanish/bd_practice_screen_active_state.mp3';
import vocabBDPracticeReadyInstruction from '../sounds/vocab_bd_practice_ready_instruction.mp3';
import vocabBDPracticeReadyInstructionSpanish from '../sounds/spanish/bd_practice_screen_ready_state.mp3';
import vocabPracticeClickOk from '../sounds/click_ok.mp3';
import vocabPracticeClickOkSpanish from '../sounds/spanish/clic_continuare.mp3';
import { LANGUAGES } from '../common/localization';

export const VOCAB_AUDIO_INSTRUCTIONS = {
    [LANGUAGES.ENGLISH]: {
        vocabTQVMPracticeInstructionStart,
        vocabTQVMPracticeReadyInstruction,
        vocabTQVMQuestionInstructionReplay,
        vocabFITBPracticeInstructionStart,
        vocabFITBInstructionReplay,
        vocabFITBPracticeReadyInstruction,
        vocabBDPracticeInstructionStart,
        vocabBDPracticeReadyInstruction,
        clickOk: vocabPracticeClickOk,
    },
    [LANGUAGES.SPANISH]: {
        vocabTQVMPracticeInstructionStart: vocabTQVMPracticeInstructionStartSpanish,
        vocabTQVMPracticeReadyInstruction: vocabTQVMPracticeReadyInstructionSpanish,
        vocabTQVMQuestionInstructionReplay: vocabTQVMQuestionInstructionReplaySpanish,
        vocabFITBPracticeInstructionStart: vocabFITBPracticeInstructionStartSpanish,
        vocabFITBInstructionReplay: vocabFITBInstructionReplaySpanish,
        vocabFITBPracticeReadyInstruction: vocabFITBPracticeReadyInstructionSpanish,
        vocabBDPracticeInstructionStart: vocabBDPracticeInstructionStartSpanish,
        vocabBDPracticeReadyInstruction: vocabBDPracticeReadyInstructionSpanish,
        clickOk: vocabPracticeClickOkSpanish,
    },
};

export const VOCAB_GRADES_WITH_AUTOPLAY = ['KG', '01'];

export const TQVM_GRADES_WITH_INTERSTITIAL = ['KG'];
export const FITB_GRADES_WITH_INTERSTITIAL = ['01'];
